import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { ordersApi } from '../api/orders';
import { toErrorMessage } from '../api/client';
import { useStores } from '../auth/StoreContext';
import { Card, PageHead } from '../components/ui';
import { Empty, ErrorState, Loading } from '../components/DataStates';
import { StoreSelector } from '../components/StoreSelector';
import { dateTime, money } from '../lib/format';

export function CancelledBillsPage() {
  const { selectedStoreId } = useStores();

  const q = useQuery({
    queryKey: ['cancelled', selectedStoreId],
    enabled: selectedStoreId != null,
    queryFn: () => ordersApi.cancelled(selectedStoreId),
  });

  return (
    <>
      <PageHead
        title="Cancelled Bills"
        subtitle="Voided bills remain in history for audit."
        actions={<StoreSelector />}
      />
      <Card>
        {selectedStoreId == null ? (
          <Empty icon="🏬" title="Select a store" />
        ) : q.isLoading ? (
          <Loading />
        ) : q.isError ? (
          <ErrorState message={toErrorMessage(q.error)} onRetry={q.refetch} />
        ) : !q.data || q.data.length === 0 ? (
          <Empty icon="🚫" title="No cancelled bills" />
        ) : (
          <div className="table-wrap">
            <table className="data">
              <thead>
                <tr>
                  <th>Bill No.</th><th>Date / Time</th><th>Cashier</th>
                  <th className="text-right">Total</th><th></th>
                </tr>
              </thead>
              <tbody>
                {q.data.map((o) => (
                  <tr key={o.orderId}>
                    <td><strong>{o.billNumber}</strong></td>
                    <td>{dateTime(o.createdAt)}</td>
                    <td>{o.cashierName}</td>
                    <td className="text-right">{money(o.grandTotal)}</td>
                    <td className="text-right">
                      <Link className="btn btn-secondary btn-sm" to={`/bills/${o.orderId}`}>View</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </>
  );
}
